export default __webpack_public_path__ + "static/media/samsun.8b8e9bf6.png";